import { useCallback, useMemo, useState } from "react";

export interface ModalProps {
    visible: boolean;
    onCancel: () => void;
}

export type ShowModal<TContext> = (context?: TContext) => void;

export const useModal = <TContext = unknown>(
    visibleByDefault: boolean = false,
): [ModalProps, ShowModal<TContext>, TContext | null] => {
    const [visible, setModalVisible] = useState(visibleByDefault);
    const [context, setContext] = useState<TContext | null>(null);

    const showModal = useCallback<ShowModal<TContext>>((newContext: TContext | null = null) => {
        setContext(newContext);
        setModalVisible(true);
    }, []);

    const onCancel = useCallback(() => {
        setContext(null);
        setModalVisible(false);
    }, []);

    const modalProps = useMemo(
        () => ({
            visible,
            onCancel,
        }),
        [visible, onCancel],
    );

    return [modalProps, showModal, context];
};
